<template>
  <div>
    <section class="section-md section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 shape-dark shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-150">
        <span>&nbsp;</span>
        <div class="row text-center justify-content-center">
          <div class="col-lg-6">
            <h2 class="display-3 text-white" style="margin-top: 2.5rem">Commercial solutions</h2>
            <h4 class="text-white">Network management software</h4>
            <h4 class="text-white">Security software</h4>
          </div>
        </div>
        <div class="text-center">
          <base-button type="primary" class="mt-4 bg-gradient-primary">
            <a href="#/contact-us" class="text-white"> Get in touch! </a>
          </base-button>
        </div>
      </div>
    </section>
    <section class="section section-sm TEAM">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col">
            <div class="">
              <img
                v-lazy="'./img/brand/brand-logo2.png'"
                class="lead img-fluid"
                width="50%"
                height="auto"
                style="margin-top: 3rem; display: block; margin-left: auto; margin-right: auto;"
              />
            </div>
            <p class="lead text-muted" style="text-align: justify"></p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col">
            <p class="lead text-muted" style="text-align: justify">
              <b>We offer products and services including both the offer of global technology suppliers and proprietary solutions. We specialize in ICT integration based on well-known commercial solutions.</b>
            </p>
            <div class="offerDescription">
              <p class="lead text-muted" style="text-align: justify">
                <b>Software integration:</b> As part of the integration, we promote reliable and easy-to-license software.
              </p>
              <p class="lead text-muted" style="text-align: justify">
                <b>Network monitoring tools (observability) SOLARWINDS, DataDog:</b> Our team designs and performs the preparation of modules and required components for monitoring systems for specific applications in the customer's network environment.
              </p>
              <p class="lead text-muted" style="text-align: justify">
                <b>Security tools - Firemon Security Manager:</b> As part of designing a secure infrastructure with data and application protection, we offer the highest level of cloud security with solutions to help manage data.
              </p>
              <p class="lead text-muted" style="text-align: justify">
                <b>SIEM, SOAR and UEBA tools - LOGPOINT:</b> We integrate a SIEM Security Information & Event Management class system for security events and information management, which is Common Criteria (CC) certified at EAL3+ level.
              </p>
            </div>
              
            <p class="lead text-muted" style="text-align: center">
              <b>Extended offer in .pdf file:</b>
            </p>
            <div class="">
              <a href='https://pdf-open-sagaca.s3.amazonaws.com/Opis_us%C5%82ugi_produkty_SAGACA._2023+(2).pdf' target="_blank">
              <img
                v-lazy="'./img/pdflogodownload.png'"
                class="lead img-fluid"
                width="8%"
                height="8%"
                style="display: block; margin-left: auto; margin-right: auto;"
              />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
import AWS from "aws-sdk";
import "dotenv/config";
export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      message: "",
      name: "",
      email: "",
    };
  },
  methods: {
    scrollToElement(options) {
      const transcriptionSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden"
      )[0];
      if (transcriptionSection) {
        transcriptionSection.scrollIntoView(options);
      }
    },
    scrollToElement1(options1) {
      const matcherSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden matcher"
      )[0];
      if (matcherSection) {
        matcherSection.scrollIntoView(options1);
      }
    },
    scrollToElement2(options2) {
      const teamSection = this.$el.getElementsByClassName("section section-sm TEAM")[0];
      if (teamSection) {
        teamSection.scrollIntoView(options2);
      }
    },
    scrollToElement3(options3) {
      const teamSection = this.$el.getElementsByClassName(
        "section section-sm Technologies"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options3);
      }
    },
    scrollToProducts(options4) {
      const teamSection = this.$el.getElementsByClassName(
        "section section section-shaped my-0 overflow-hidden PRODUCTS"
      )[0];
      if (teamSection) {
        teamSection.scrollIntoView(options4);
      }
    },
  },
};
</script>
